import { Controller } from "@hotwired/stimulus";

const PLACEHOLDER_RE = /\[[^\]]+\]/g;

export default class TitleTemplateController extends Controller {
  static targets = ["select", "titleInput"];

  apply() {
    const template = this.selectTarget.value;
    if (!template) return;
    this.titleInputTarget.value = template;
    this.titleInputTarget.focus();
    this.#selectPlaceholderAt(0);
    // Reset select so the placeholder option shows again
    this.selectTarget.value = "";
  }

  tabThrough(event) {
    if (event.key !== "Tab") return;
    const input = this.titleInputTarget;
    const val = input.value;
    const selStart = input.selectionStart;
    const selEnd = input.selectionEnd;

    const matches = [...val.matchAll(PLACEHOLDER_RE)];
    if (!matches.length) return;

    const currentIdx = matches.findIndex(
      (m) => m.index === selStart && m.index + m[0].length === selEnd,
    );

    let nextIdx;
    if (event.shiftKey) {
      nextIdx = currentIdx <= 0 ? matches.length - 1 : currentIdx - 1;
    } else {
      if (currentIdx === -1 || currentIdx === matches.length - 1) return;
      nextIdx = currentIdx + 1;
    }

    event.preventDefault();
    this.#selectPlaceholderAt(nextIdx);
  }

  #selectPlaceholderAt(idx) {
    const val = this.titleInputTarget.value;
    const matches = [...val.matchAll(PLACEHOLDER_RE)];
    if (!matches[idx]) return;
    const m = matches[idx];
    this.titleInputTarget.setSelectionRange(m.index, m.index + m[0].length);
  }
}
